import { AntragMetaData, FormResult, FormValue } from '../model';
import { AntragMetaDataDto } from '../dto/antrag-meta-data';
import { FormValueDto } from '../dto/form-value.dto';
import { GenericDtoAssemblerService, Guid } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AntragMetaDataDtoAssemblerService extends GenericDtoAssemblerService<AntragMetaData, AntragMetaDataDto> {
  public toDto(antragMetadata: AntragMetaData): AntragMetaDataDto {
    return new AntragMetaDataDto(
      antragMetadata.formResults.map((formResults) => ({
        templateName: formResults.templateName,
        formId: formResults.formId.toString(),
        isValid: formResults.isValid,
        createdAt: formResults.createdAt,
        isMandatory: formResults.isMandatory,
        results: formResults.results.filter((element) => element.value != undefined).map(this.createFormValueDto),
      })),
    );
  }

  public fromDto(antragMetaDataDto: AntragMetaDataDto): AntragMetaData {
    return new AntragMetaData({
      formResults: antragMetaDataDto.formResults.map(
        (formResultsDto) =>
          new FormResult({
            templateName: formResultsDto.templateName,
            formId: Guid.create(formResultsDto.formId),
            createdAt: formResultsDto.createdAt,
            isValid: formResultsDto.isValid,
            isMandatory: formResultsDto.isMandatory,
            results: formResultsDto.results.map(this.createFormValue),
          }),
      ),
    });
  }

  private createFormValueDto(formValue: FormValue): FormValueDto {
    return new FormValueDto(formValue.$type, formValue.name, formValue.value, formValue.parent);
  }

  private createFormValue(formValueDto: FormValueDto): FormValue {
    return FormValue.create(formValueDto.$type, formValueDto.name, formValueDto.value, formValueDto.parent);
  }
}
